import { render, staticRenderFns } from "./SearchResultSection.vue?vue&type=template&id=4dfe2915&scoped=true&"
import script from "./SearchResultSection.vue?vue&type=script&lang=ts&"
export * from "./SearchResultSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe2915",
  null
  
)

export default component.exports